import React from "react";
import PropTypes from "prop-types";
import { ImageViewer } from "@components";
import BienCarousel from "./BienCarousel";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import { isEmpty, isUndefined } from "lodash";
import { animations } from "react-animation";
import { maskCurrency } from "@helpers/utils";
import useMediaQuery from "app/hooks/useMediaQuery";

const root = process.env.REACT_APP_CMS_STATIC;

BienDetalle.propTypes = {
  bienInfo: PropTypes.object,
  setCurBien: PropTypes.func,
  btnSolicitarInfo: PropTypes.object,
  btnCotizar: PropTypes.object
};

const BORDER_TOP_COLOR = "#d7de00";

function BienDetalle({
  bienInfo = {},
  setCurBien,
  btnSolicitarInfo = {},
  btnCotizar = {},
  ...props
}) {

  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");

  const formatFiles = (arrFiles) => {
    return arrFiles?.map((file) => {
      return { fileURL: file, fileName: file?.replace(/^.*[\\/]/, "") };
    });
  };

  const obtenerImagenBoton = (objBoton) => {
    const imagenFullHD = objBoton?.imagenFullHD?.urls[0];
    const imagenIPad = objBoton?.imagenIPad?.urls[0];
    const imagenIphone = objBoton?.imagenIPhone?.urls[0];

    if (is4K || isFullHD || isMidLaptop) {
      return root + imagenFullHD;
    } else if(isIpadLandscape || isIpadPortrait) {
      return root + imagenIPad;
    } else {
      return root + imagenIphone;
    }
  };

  let imagenBotonSolicitar = obtenerImagenBoton(btnSolicitarInfo);
  let imagenBotonCotizar = obtenerImagenBoton(btnCotizar);

  const renderMapa = (latitud, longitud, otrasSenas) => {
    const seccionInicial = `
      <div>
        ${otrasSenas}
      </div>
    `;
    const seccionMapa = `
      <div className="bienes-map-container">
        <iframe
          loading="lazy"
          allowfullscreen
          referrerpolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}
            &q=${latitud},${longitud}&zoom=14"
        >
        </iframe>
      </div>
    `;
    return `
      <div>
        ${seccionInicial}
        ${latitud !== null && longitud !== null ? seccionMapa : ""}
      </div>
    `;
  };

  return (
    <div
      id="resultadosBusquedaContainer"
      className="resultados-busqueda-contenedor"
      style={{ animation: animations.fadeIn }}
    >
      <div
        className="text-secondary fs-3 ps-5 pb-3 text-start custom-link"
        onClick={() => setCurBien(0)}
      >
        ◀ Volver a resultados
      </div>
      <div className="d-flex flex-wrap justify-content-between">
        <div className="d-flex flex-column">
          <div className="text-start fs-5 text-secondary">
            {bienInfo.TipoBien} {bienInfo.NumeroExpediente}
          </div>
          <div className="text-start fs-5 text-secondary fw-bold">
            ₡ {maskCurrency(bienInfo.Precio)}
            {/* ₡ {new Intl.NumberFormat("es-CR").format(bienInfo.Precio)} */}
          </div>
        </div>
      </div>
      <div className="bienes-carousel-container">
        <BienCarousel listaImagenes={bienInfo.Imagenes} />
      </div>
      <div className="bienes-image-viewer">
        <ImageViewer arrImages={bienInfo.Imagenes} />
      </div>

      <div id="dataBien">
        <CardTypeFolder
          title="Descripción"
          description={
            !isUndefined(bienInfo.Descripcion) ? bienInfo.Descripcion : ""
          }
          borderTopColor={BORDER_TOP_COLOR}
        />
        <CardTypeFolder
          title="Ubicación exacta"
          description={renderMapa(bienInfo.Latitud, bienInfo.Longitud, bienInfo.OtrasSenas)}
          borderTopColor={BORDER_TOP_COLOR}
        />
        <CardTypeFolder
          title="Características"
          description={bienInfo.Caracteristicas}
          borderTopColor={BORDER_TOP_COLOR}
        />
        <CardTypeFolder
          title="Folio real"
          description={bienInfo.NumeroExpediente}
          borderTopColor={BORDER_TOP_COLOR}
        />
        {!isEmpty(bienInfo.Documentos) && (
          <CardTypeFolder
            title="Documentos"
            description={" "}
            borderTopColor={BORDER_TOP_COLOR}
            files={formatFiles(bienInfo.Documentos)}
          />
        )}
        <CardTypeFolder
          title="Contacto"
          description={bienInfo.InformacionContacto || "Sin información de contacto"}
          borderTopColor={BORDER_TOP_COLOR}
        />
        <div className="bienes-botones-container">
          {imagenBotonSolicitar !== undefined ? (
            <img
            src={imagenBotonSolicitar}
            className="custom-link"
            style={{ animation: animations.fadeIn }}
            alt="Solicitar información"

            onClick={() => window.open(btnSolicitarInfo.enlace)}
          />
          ) : (<></>)}
          {imagenBotonCotizar !== undefined ? (
            <img
            src={imagenBotonCotizar}
            className="custom-link"
            style={{ animation: animations.fadeIn }}
            alt="Cotizar"
   
            onClick={() => window.open(btnCotizar.enlace)}
          />
          ) : (<></>)}
        </div>
      </div>
    </div>
  );
}

export default BienDetalle;
